import { memo, useEffect } from "react";
import { useAtomValue, useSetAtom } from 'jotai';
import { allDisplayedDataBoundsAtom, mapDataDisplayedBoundsAtom } from "../stores/mapStore";
import { elementDisplayedBoundsAtom } from "../Element/ElementStore";
import { commentDisplayedBoundsAtom } from "../Comment/CommentStore";
import { memberDisplayedBoundsAtom } from "../Member/MemberStore";
import { LngLatBounds } from "maplibre-gl";

const AllDisplayedDataBoundsController = () => {

  const mapDataBounds = useAtomValue(mapDataDisplayedBoundsAtom);
  const elementBounds = useAtomValue(elementDisplayedBoundsAtom);
  const commentBounds = useAtomValue(commentDisplayedBoundsAtom);
  const memberBounds = useAtomValue(memberDisplayedBoundsAtom);
  const setAllDisplayedDataBounds = useSetAtom(allDisplayedDataBoundsAtom);

  useEffect(() => {

    const boundsStrings = [mapDataBounds, elementBounds, commentBounds, memberBounds]
      .filter(boundsStr => boundsStr !== null);

    console.log('AllDisplayedDataBoundsController - mapDataBounds:', mapDataBounds);
    console.log('AllDisplayedDataBoundsController - boundsStrings:', boundsStrings);

    if (boundsStrings.length === 0) {
      setAllDisplayedDataBounds(null);
      return;
    }

    let combinedBounds: LngLatBounds | null = null;

    boundsStrings.forEach(boundsStr => {
      try {
        const bounds = JSON.parse(boundsStr);
        const [[west, south], [east, north]] = bounds;
        const currentBounds = new LngLatBounds([west, south], [east, north]);

        if (combinedBounds) {
          combinedBounds.extend(currentBounds);
        } else {
          combinedBounds = currentBounds;
        }
      } catch (error) {
        console.error("Error parsing bounds:", boundsStr, error);
      }
    });

    if (combinedBounds) {
      const mergedBoundsString = JSON.stringify([
        [combinedBounds.getWest(), combinedBounds.getSouth()],
        [combinedBounds.getEast(), combinedBounds.getNorth()],
      ]);
      setAllDisplayedDataBounds(mergedBoundsString);
    } else {
      setAllDisplayedDataBounds(null);
    }
  }, [mapDataBounds, elementBounds, commentBounds, memberBounds, setAllDisplayedDataBounds]);

  return null; // This is a logic-only component
};

export default memo(AllDisplayedDataBoundsController);